var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRental(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile---Event-Details",
    transform: "translate(-34.000000, -2937.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(35.000000, 2938.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 3.000000)",
    fill: "#979797",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "7.44642372 5 0.553265805 5 0 8.12972204 0.524546901 8.12972204 0.524546901 12 0.990258858 12 0.990258858 8.12972204 7.0095859 8.12972204 7.0095859 12 7.47529786 12 7.47529786 8.12972204 8 8.12972204"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "1.46298678 4.03952206 6.53701322 4.03952206 6.53701322 5 7 5 7 0 6.53701322 0 6.53701322 0.502642463 1.46298678 0.502642463 1.46298678 0 1 0 1 5 1.46298678 5"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRental);
export default __webpack_public_path__ + "static/media/Rental.fc6112f7e3df132ecc6ae009c14994cb.svg";
export { ForwardRef as ReactComponent };